import { render } from "./CardTransactionMobile.vue?vue&type=template&id=61b831ec&scoped=true"
import script from "./CardTransactionMobile.vue?vue&type=script&lang=js"
export * from "./CardTransactionMobile.vue?vue&type=script&lang=js"

import "./CardTransactionMobile.vue?vue&type=style&index=0&id=61b831ec&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b831ec"]])

export default __exports__